import * as angular from 'angular';
import * as _ from 'lodash';

import { IdentifierType, ComponentDefinition, Identifier, IdentifierDumbTableRowButton, IDisplayedColumn, GroupDisplayName } from '../../models';
import { identifierSelected } from '../../common';

class IdentifierDumbTableController implements angular.IComponentController, angular.IOnChanges {
    isLoading: boolean;
    identifierType = IdentifierType;
    displayedIdentifiers: Identifier[];

    readonly buttons: IdentifierDumbTableRowButton[];
    readonly displayed: Identifier[];
    readonly displayedName = GroupDisplayName.AbsoluteName;
    readonly menu: IDisplayedColumn[];
    readonly selectedIdentifier: Identifier;

    static $inject = ['$rootScope'];

    constructor(private _$rootScope: angular.IRootScopeService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        // #29892 Broadcast only serve for first initilization of component
        // other wise we'll refresh all component while store is updating and things breaks
        if (changesObj['displayed']?.currentValue) {
            this.displayedIdentifiers = this.displayed
                ? this.displayed
                : [];
            if (!this.selectedIdentifier && this.displayedIdentifiers && this.displayedIdentifiers.length > 0) {
                this._$rootScope.$broadcast(identifierSelected, this.displayedIdentifiers[0]);
            }
        }
    }

    isVisible(column: string): boolean {
        const found = _.find(this.menu, m => m.type === column);
        return found ? found.isVisible : false;
    }

    setClickedRow(identifier: Identifier, index: number, $event: angular.IAngularEvent): void {
        // #29892 broadcast i want to change selected
        this._$rootScope.$broadcast(identifierSelected, identifier);
    }
}

export const wtIdentifierDumbTable: ComponentDefinition = {
    componentId: 'wtIdentifierDumbTable',
    controller: IdentifierDumbTableController,
    template: require('./identifierDumbTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        buttons: '<?',
        displayed: '<',
        menu: '<',
        selectedIdentifier: '<?'
    }
};